import { useDeviceDetector } from "@/utils/useDeviceDetector";
import React from "react";
import TeamMobile from "./TeamMobile/TeamMobile";
import TeamDesktop from "./TeamDesktop/TeamDesktop";

export default function Team({ messages }) {
  const { isMobile } = useDeviceDetector();

  return (
    <>
      {isMobile ? (
        <TeamMobile messages={messages} />
      ) : (
        <TeamDesktop messages={messages} />
      )}
    </>
  );
}
